/**
 * 배포 환경 판정. vite `--mode <target>.<deployEnv>` (예 `web.production`) 에서 파생.
 *
 * prod 빌드에서만 숨겨야 하는 디버그 UI 등의 게이팅에 사용. `import.meta.env.PROD` 는
 * **모든** vite build(인하우스 dev 포함)에서 true 라 "운영 배포만" 판별엔 부적합 —
 * mode 문자열의 `.production` suffix 로 판정한다. (`web.local`=dev server → false)
 */
export const DEPLOY_MODE: string = import.meta.env.MODE;

/** 운영(production) 배포 빌드 여부. `web.production` / `native.production` 만 true. */
export const IS_PROD_BUILD = DEPLOY_MODE.endsWith('.production');
